const toBool = (value) => {
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase();
  return normalized === "1" || normalized === "true" || normalized === "yes" || normalized === "on";
};

const originalConsoleLog = console.log.bind(console);

export const configureConsoleLog = () => {
  const enabled = toBool(process.env.REACT_APP_ENABLE_CONSOLE_LOGS);
  console.log = enabled ? originalConsoleLog : () => {};
};
